import { render, staticRenderFns } from "./rego-customer-email-verification.vue?vue&type=template&id=06083729&scoped=true&"
import script from "./rego-customer-email-verification.vue?vue&type=script&lang=js&"
export * from "./rego-customer-email-verification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06083729",
  null
  
)

export default component.exports